import { render, staticRenderFns } from "./MarketplaceReviewsTableUser.vue?vue&type=template&id=0fd86b18&scoped=true"
import script from "./MarketplaceReviewsTableUser.vue?vue&type=script&lang=js"
export * from "./MarketplaceReviewsTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd86b18",
  null
  
)

export default component.exports